export default function genererDispositifTechnique() {
  return {
    restrictionsAffichage: '',
    couleurRAL: null,
    valeurAcquisition: 0,
    longueur: 0,
    publicitaire: false,
    particularite: '',
    largeurToit: 0,
    eclairable: false,
    planRecollement: '',
    cableEdfProx: false,
    distanceEnMCablesEdf: 0,
    hauteurSousPanneau: 0,
    nacelleNecessaire: false,
    grueNecessaire: false,
    echelleNecessaire: false,
    autreEquipementNecessaire: null,
    obstacle: '',
    declarationPrealable: null,
    fournisseurElectriciteId: null,
    fournisseurElectricite: null,
    tiersProprietaireId: null,
    tiersProprietaire: null,
  };
}
